
export const BaseShippingApis = ({fetcher}) => ({

    validateAddress: async (address) => {
        // [{DeliveryPointValidation: "CONFIRMED"}]
        return await fetcher.postJson(`/next-api/shipping/validate_address`, {address});
    },
});

